import { WelcomeTemplate } from "../../components/templates/Welcome"

export function Component() {
  return <WelcomeTemplate />
}
